<template>
  <div class="card compliance-graph-card" :class="headerText">
    <div class="card-content">
      <div class="compliance-header">
        <h4>{{ filter.name }}</h4>
        <h2>By {{ headerText }}</h2>
      </div>
      <div class="content" v-if="pieChart">
        <compliance-pie-chart
          :fees="pieChartFees"
          :labels="pieChartLabel"
          :position="'bottom'"
        ></compliance-pie-chart>
      </div>
      <compliance-overview-product-content
        v-if="headerText == 'product'"
        :data="contentData"
      ></compliance-overview-product-content>
      <compliance-content-comp
        v-else
        :data="contentData"
      ></compliance-content-comp>
      <div
        class="content below-link"
        v-if="
          (pieChartFees && pieChartFees.length > 0) ||
            (barChartFees && barChartFees.length > 0) ||
            (contentData && contentData.length > 0)
        "
      >
        <a ref="#" @click.prevent="moreDetails"><p>more details</p></a>
      </div>
    </div>
  </div>
</template>
<script>
import ComplianceOverviewProductContent from "./ComplianceOverviewProductContent.vue";
import ComplianceContentComp from "./ComplianceContentComp.vue";
import CompliancePieChart from "./CompliancePieChart.vue";
export default {
  components: {
    CompliancePieChart,
    ComplianceContentComp,
    ComplianceOverviewProductContent
  },
  name: "ComplianceGraphCard",
  props: {
    headerText: {
      type: String,
      default: "Country"
    },
    barChart: {
      type: Boolean,
      default: false
    },
    pieChart: {
      type: Boolean,
      default: false
    },
    contentData: [],
    barChartFees: [],
    barChartCategories: [],
    pieChartLabel: [],
    pieChartFees: [],
    filter: {
      type: Object,
      default: () => {
        return {
          name: "Highest Fee",
          value: "total_fee",
          order: "desc"
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    moreDetails() {
      this.$emit("moreDetails");
    }
  }
};
</script>
